import type { OrderRefundApi } from "../../api/OrderRefundApi";
import type { CashDrawerChangeFetchOptions } from "../../generated/dto/CashDrawerChangeFetchOptions";
import type { CashDrawerChangeStaff } from "../../generated/dto/CashDrawerChangeStaff";
import type { LineItemRefundFetchOptions } from "../../generated/dto/LineItemRefundFetchOptions";
import type { LineItemRefundStaff } from "../../generated/dto/LineItemRefundStaff";
import type { OrderFetchOptions } from "../../generated/dto/OrderFetchOptions";
import type { OrderPaymentFetchOptions } from "../../generated/dto/OrderPaymentFetchOptions";
import type { OrderPaymentStaff } from "../../generated/dto/OrderPaymentStaff";
import type { OrderRef } from "../../generated/dto/OrderRef";
import type { OrderRefundFetchOptions } from "../../generated/dto/OrderRefundFetchOptions";
import type { OrderRefundPreview } from "../../generated/dto/OrderRefundPreview";
import type { OrderRefundPreviewRequest } from "../../generated/dto/OrderRefundPreviewRequest";
import type { OrderRefundReconciliation } from "../../generated/dto/OrderRefundReconciliation";
import type { OrderRefundRequest } from "../../generated/dto/OrderRefundRequest";
import type { OrderRefundResult } from "../../generated/dto/OrderRefundResult";
import type { OrderRefundStaff } from "../../generated/dto/OrderRefundStaff";
import type { OrderStaff } from "../../generated/dto/OrderStaff";
import type { PaymentRefundFetchOptions } from "../../generated/dto/PaymentRefundFetchOptions";
import type { PaymentRefundStaff } from "../../generated/dto/PaymentRefundStaff";

export class OrderRefundFrontendService {
  constructor(private readonly api: OrderRefundApi) {}
  async getOrderRefundStaff(id: number, options?: OrderRefundFetchOptions): Promise<OrderRefundStaff> {
    return this.api.getOrderRefundStaff(id, options)
  }
  async getPaymentRefundStaff(id: number, options?: PaymentRefundFetchOptions): Promise<PaymentRefundStaff> {
    return this.api.getPaymentRefundStaff(id, options)
  }
  async getOrderRefundStaffOrderId(id: number, options?: OrderFetchOptions): Promise<OrderStaff> {
    return this.api.getOrderRefundStaffOrderId(id, options)
  }
  async getOrderRefundStaffLineItemRefunds(id: number, options?: LineItemRefundFetchOptions): Promise<Array<LineItemRefundStaff>> {
    return this.api.getOrderRefundStaffLineItemRefunds(id, options)
  }
  async getOrderRefundStaffPaymentRefunds(id: number, options?: PaymentRefundFetchOptions): Promise<Array<PaymentRefundStaff>> {
    return this.api.getOrderRefundStaffPaymentRefunds(id, options)
  }
  async getPaymentRefundStaffCashDrawerChange(id: number, options?: CashDrawerChangeFetchOptions): Promise<CashDrawerChangeStaff | null> {
    return this.api.getPaymentRefundStaffCashDrawerChange(id, options)
  }
  async getPaymentRefundStaffOrderRefundId(id: number, options?: OrderRefundFetchOptions): Promise<OrderRefundStaff> {
    return this.api.getPaymentRefundStaffOrderRefundId(id, options)
  }
  async getPaymentRefundStaffPaymentId(id: number, options?: OrderPaymentFetchOptions): Promise<OrderPaymentStaff> {
    return this.api.getPaymentRefundStaffPaymentId(id, options)
  }
  async markOrderRefundedStaff(order: OrderRef): Promise<OrderRefundReconciliation> {
    return this.api.markOrderRefundedStaff(order)
  }
  async previewOrderRefundStaff(request: OrderRefundPreviewRequest): Promise<OrderRefundPreview> {
    return this.api.previewOrderRefundStaff(request)
  }
  async refundOrderStaff(request: OrderRefundRequest): Promise<OrderRefundResult> {
    return this.api.refundOrderStaff(request)
  }
}
